<template>
    <el-dialog :title="dialogTitle" :visible.sync="authorizedPersonnelVisible" width="600px" :before-close="handleDialogClose" :close-on-click-modal="false"
        class="custom-form-dialog">
        <div class="custom-dialog-content">
            <div class="left_selectable_wrap ">
                <ul class="custom-tabbar">
                    <li v-for="(tabItem, tabIndex) in dialogTabList" :key="tabIndex" @click="handleClickDialogTab(tabItem.name)" :class="{ active: tabItem.name == activeTabName }">
                        <span>{{ tabItem.label }}</span>
                    </li>
                </ul>
                <div style="padding: 16px">
                    <el-input v-model="keyWord" size="small" placeholder="请输入" @keyup.enter.native="getDepartmentAndUserList">
                        <i slot="suffix" class="iconfont icon-sousuo" @click="getDepartmentAndUserList"></i>
                    </el-input>
                </div>
                <div class="scroll_wrap">
                    <el-tree :data="selectable_list" :expand-on-click-node='false' :default-expanded-keys="default_expanded" ref="dep_and_user_tree" show-checkbox
                        node-key="relate_type_id" check-on-click-node check-strictly :props="defaultProps" @check="handleCheckNodeItem">
                    </el-tree>
                </div>
            </div>
            <div class="right_selected_wrap">
                <div class="title_wrap">
                    <span class="font-bold">已选</span>
                    <div v-if="selected_list.length > 0">
                        <span v-if="selected_list.filter(item => item.relate_type === '2').length" v-text="selected_list.filter(item => item.relate_type === '2').length + '个部门'">
                        </span>
                        &nbsp;
                        <span v-if="selected_list.filter(item => item.relate_type === '1').length" v-text="selected_list.filter(item => item.relate_type === '1').length + '个人员'">
                        </span>
                    </div>

                    <i @click="hanleClickClear">清除</i>
                </div>
                <ul class="selected_list">
                    <li class="selected_item" v-for="(item, index) in selected_list" :key="item.relate_id">
                        <span v-text="item.relate_name"></span>
                        <el-button type="text" icon="el-icon-error" @click="handleClickDelSelected(item, index)">
                        </el-button>
                    </li>
                </ul>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm">确认</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        authorizedPersonnelVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            dialogTitle: "授权人员",
            activeTabName: "1",
            dialogTabList: [
                { label: "部门", name: "1" },
                { label: "人员", name: "2" },
                { label: "人员标签", name: "3" },
            ],
            selectable_list: [],
            default_expanded: [],
            defaultProps: {
                children: '_child',
                label: 'relate_name'
            },
            selected_list: [],
            keyWord: ''
        }
    },
    mounted() {
        this.getDepartmentAndUserList()
    },
    methods: {
        handleClickDialogTab(activeTabName) {
            this.activeTabName = activeTabName
        },
        getDepartmentAndUserList() {
            const data = [
                {
                    relate_id: 1,
                    relate_type: "1",
                    relate_name: "北京澜景科技有限公司",
                    _child: [
                        {
                            relate_id: 2,
                            relate_type: "1",
                            relate_name: "销售部",
                            _child: [
                                {
                                    relate_id: 3,
                                    relate_type: "1",
                                    relate_name: "销售一部",
                                }
                            ]
                        }
                    ]

                }
            ]
            this.deepAddRelateType(data)
            this.selectable_list = data
        },

        deepAddRelateType(arr) {
            arr.forEach(item => {
                item.relate_type_id = item.relate_id + item.relate_type
                if (item._child && item._child.length > 0) {
                    this.deepAddRelateType(item._child)
                }
            })
        },
        handleCheckNodeItem(data, { checkedKeys, checkedNodes }) {
            const dataIndex = checkedKeys.findIndex(check => check === data.relate_type_id)
            if (dataIndex > -1) {
                this.selected_list.push({
                    relate_id: data.relate_id,
                    relate_name: data.relate_name,
                    relate_type: data.relate_type,
                    relate_type_id: data.relate_type_id,
                })
            } else {
                this.selected_list.splice(this.selected_list.findIndex(item => item.relate_type_id === data.relate_type_id), 1)
            }
        },

        handleClickDelSelected(item, index) {
            this.selected_list.splice(index, 1)
            this.$refs.dep_and_user_tree.setChecked(item.relate_type_id, false)
        },
        hanleClickClear() {
            this.selected_list = []
            this.$forceUpdate()
        },
        handleDialogClose() {
            this.$emit("update:authorizedPersonnelVisible", false)
        },
        handleDialogConfirm() {
            this.$emit("selectAuthorizedData", {
                text: "2个部门5个人员"
            })
            this.$emit("update:authorizedPersonnelVisible", false)
        },

    }
}
</script>
<style lang="scss">
.custom-form-dialog {
    .custom-dialog-content {
        display: flex;
        gap: 16px;

        .el-input {
            .el-input__suffix {
                right: 12px;
            }

            .el-input__suffix-inner {
                height: 32px;
                line-height: 32px;
                display: flex;
                align-items: center;
            }
        }


        .left_selectable_wrap {
            flex: 1;
            height: 410px;
            border-radius: 6px;
            border: 1px solid #f3f3f3;

            .scroll_wrap {
                padding: 0 16px;
                width: 100%;
                height: calc(100% - 110px);
                overflow-y: scroll;
            }

            .custom-tabbar li {
                height: 44px;
                line-height: 44px;
            }

            .el-tree-node__content {
                height: 30px;
                margin-bottom: 4px;
            }
        }

        .right_selected_wrap {
            flex: 1;
            height: 410px;
            border-radius: 6px;
            border: 1px solid #f3f3f3;

            .selected_list {
                width: 100%;
                height: calc(100% - 55px);
                overflow-y: scroll;

                .selected_item {
                    padding: 0 16px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 30px;
                    cursor: pointer;

                    .el-button {
                        font-size: 16px;
                        color: #BFBFBF;
                        display: none;
                    }

                    &:hover {
                        background-color: rgba(0, 0, 0, .04);

                        .el-button {
                            display: block;
                        }
                    }
                }
            }
        }

        .title_wrap {
            height: 44px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            padding: 0 16px;
            display: flex;
            align-items: center;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 12px;
            position: relative;

            .font-bold {
                font-size: 16px;
                font-weight: 700;
                color: rgba(51, 51, 51, 1);
            }

            i {
                font-size: 14px;
                color: #E44144;
                position: absolute;
                right: 16px;
                cursor: pointer;
            }
        }
    }
}
</style>
